import OtpInput from "react-otp-input";

const COTPInput = ({ otp, setOtp, shouldAutoFocus }) => {
  return (
    <div className="flex justify-center w-[200px] bg-[#2C2D36] border-[#444444] border rounded-3xl px-4 py-3">
      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        inputType="number"
        shouldAutoFocus={shouldAutoFocus}
        containerStyle={"gap-[10px]"}
        renderInput={(props) => {
          const isFilled = props.value === 0 || props.value;
          return (
            <input
              {...props}
              className={`bg-[#2C2D36] border-b pb-1 focus:border-white hide-number-input-spin ${
                isFilled ? "border-white" : "border-[#555555]"
              } focus:outline-none`}
            />
          );
        }}
      />
    </div>
  );
};

export default COTPInput;
